import React from 'react';
import { UTDialog as Dialog, UTButton } from '@widergy/energy-ui';

const UTDialog = props => <Dialog {...props} ButtonComponent={UTButton} />;

export default UTDialog;
